// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___xTNbe","root__title":"style-module__root__title___kHr6I"};
    if(module.hot) {
      // 1729151130490
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  